import { faPlus, faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Input, Modal } from "@mantine/core";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { createB2BAPI } from "../../../api/Interceptor.jsx";
import B2BButton from "../../common/B2BButton";
import { statesData } from "../json/StatesData.js";
import { useLocation, useNavigate } from "react-router-dom";
import AmountDisplayed from "../../../utils/AmountDisplayed.jsx";
import { useMediaQuery } from "@mantine/hooks";
import _ from "lodash";

export default function Shipping({
  cartData,
  cartInfo,
  setSelectedAddresses,
  selectedAddresses,
  handleNextStep,
  delivery,
  setDelivery,
  price,
  valueOption,
  payment,
  setPayment,
  combo,
  profile,
  loyalty,
  uom,
}) {
  const navigate = useNavigate();
  const B2B_API = useMemo(() => createB2BAPI(navigate), [navigate]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSecondModalOpen, setIsSecondModalOpen] = useState(false);
  const [modelHeader, setModalHeader] = useState("");
  const addref = useRef(null);
  const [addresses, setAddresses] = useState([]);
  const [errors, setErrors] = useState({});
  const [isEditMode, setIsEditMode] = useState(false);
  const [addresserror, setAddressError] = useState(false);
  const [deliveryModeError, setDeliveryModeError] = useState(false);
  const [cityOptions, setCityOptions] = useState([]);
  const [lastOrderByCustomer, setLastOrderByCustomer] = useState([]);
  const [loginUser, setLoginUser] = useState(
    JSON.parse(localStorage.getItem("user"))
  );
  const [customer, setCustomer] = useState([]);
  const LocationType = {
    billLocation: "Bill Location",
    shipLocation: "Ship Location",
  };
  const location = useLocation();
  const { cartItems, subTotal, total, priceSlab, cartType } =
    location.state || {};
  const sampleCart = cartData[0]?.cartType === "SAMPLE";
  const swatchCart = cartData[0]?.cartType === "SWATCH";
  const comboCart = combo;
  const wholesaleCart = !sampleCart && !swatchCart && !comboCart;
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [selectedOption, setSelectedOption] = useState("");
  useEffect(() => {
    if (loginUser) {
      getLastCustomerOrder();
    }
  }, []);
  const getDiscountForVariant = (pimVariantId, cartType) => {
    const priceSlabs = price[pimVariantId];
    if (!priceSlabs) return 0;

    const matchingSlab = priceSlabs.filter(
      (priceSlab) => priceSlab.orderType === cartType
    )[0];

    return matchingSlab ? matchingSlab.discount || 0 : 0;
  };
  useEffect(() => {
    fetchAllProfile();
  }, []);
  const getCartType = () => {
    if (cartData[0]?.cartType === "SAMPLE") {
      return "Sample Cart";
    } else if (cartData[0]?.cartType === "SWATCH") {
      return "Swatch Cart";
    } else {
      return "Wholesale Cart";
    }
  };

  const [formAddressData, setFormAddressData] = useState({
    nickName: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    pincode: "",
    country: "",
    mobileNo: "",
    email: "",
  });

  const openModal = (type) => {
    setModalHeader(type);
    setIsModalOpen(true);
  };
  const closeModal = () => setIsModalOpen(false);
  const openSecondModal = () => setIsSecondModalOpen(true);

  const closeSecondModal = () => {
    setIsSecondModalOpen(false);
    setIsEditMode(false);
    setFormAddressData({
      address1: "",
      address2: "",
      city: "",
      state: "",
      pincode: "",
      country: "",
      mobileNo: "",
      email: "",
    });
  };
  const getItemCount = () => {
    if (sampleCart || swatchCart || comboCart) {
      return cartData.length;
    } else if (wholesaleCart) {
      return cartInfo?.totalItems || 0;
    }
    return 0;
  };
  // const getDiscountForVariant = (pimVariantId, cartType) => {
  //   const priceSlabs = price[pimVariantId];
  //   if (!priceSlabs) return 0;

  //   const matchingSlab = priceSlabs.find(
  //     (priceSlab) => priceSlab.orderType === cartType
  //   );
  //   return matchingSlab ? matchingSlab.discount || 0 : 0;
  // };

  const getTotalLabel = () => {
    const count = cartInfo?.subTotal || 0;
    return `${count} ${count !== 1 ? "Products" : "Product"}`;
  };
  const handleRefAddress = () => {
    if (addref.current) {
      addref.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };


  const fetchAllProfile = async () => {
    try {
      const res = await B2B_API.get(`customer/profile`);
      const data = await res.json();
      setCustomer(data?.response || []);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };


  const handleSubmit = () => {
    if (!delivery) {
      setDeliveryModeError(true);
      return false;
    }
    setDeliveryModeError(false);
    return true;
  };

  const handleDelveryModeChange = (event) => {
    setDelivery(event.target.value);
    setDeliveryModeError(false);
    setSelectedOption(event?.target?.value);
  };

  const fetchAllAddresses = async () => {
    try {
      const res = await B2B_API.get(
        `locations/verified?picked=${delivery === "PICKUP"}`
      );
      const data = await res.json();

      const finalres = data.response?.filter((g) => g.isGstVerified);
      // const finalres = data.response?.filter((g) => g.isGstVerified);

      if (finalres.length === 1) {
        setSelectedAddresses({
          shipLocation: finalres[0],
          billLocation: finalres[0],
        });
      }
      let primaryAddress = finalres.find((g) => g.isPrimary);
      if (primaryAddress) {
        setSelectedAddresses({
          shipLocation: primaryAddress,
          billLocation: primaryAddress,
        });
      }
      setAddresses(finalres || []);
    } catch (error) {
      console.error("Error fetching addresses:", error);
    }
  };

  const handleSave = async () => {
    if (!validateAddress()) return;
    try {
      const res = await B2B_API.post(`customer/location`, {

        json: formAddressData,
      });
      fetchAllAddresses();
      closeSecondModal();
    } catch (error) {
      console.error("Error on adding address:", error);
    }
  };

  const handleEdit = (addr) => {
    setFormAddressData(addr);
    setIsEditMode(true);
    openSecondModal();
  };

  const getLastCustomerOrder = async () => {
    try {
      const res = await B2B_API.get(
        `order/get-last-customer/${loginUser?.userId}`
      ).json();
      setLastOrderByCustomer(res.response);
    } catch (e) {
      console.log("Fail to Fetch Last customer", e);
    }
  };
  const calculateSubtotal = () => {
    let subtotal = 0;

    if (sampleCart) {
      subtotal = cartData.reduce((sum, item) => {


        return sum + item.sellingPrice * item.quantity;
      }, 0);
    } else if (swatchCart) {
      subtotal = cartData.reduce((sum, item) => {

        return sum + item.sellingPrice * item.quantity;
      }, 0);
    } else if (comboCart) {
      subtotal = cartData.reduce((sum, item) => {
        return (
          sum +
          (item.combo?.sellingPrice *
            item.combo?.quantity *
            item.variants?.length || 0)
        );
      }, 0);
    } else if (wholesaleCart) {
      subtotal = cartInfo?.subTotal || 0;
    }

    return subtotal.toFixed(2);
  };
  const subtotall = cartData.reduce((sum, item) => {
    if (item.combo) {
      const qty = item.combo.quantity * (item.variants?.length || 0);
      const unitPrice = Number(item.combo.sellingPrice) || 0;
      const rib = item?.variants?.map((v) => {
        const ribItem = v?.ribItem;
        if (ribItem && ribItem.sellingPrice && ribItem.quantity) {
          return ribItem.sellingPrice * ribItem.quantity;
        }
        return 0;
      });

      const ribTotal = _.sum(rib);
      return sum + qty * unitPrice + ribTotal;
    } else {


      const unitPrice = item.sellingPrice || 0;
      const rib = item?.ribItem?.sellingPrice * item?.ribItem?.quantity || 0;
      return sum + unitPrice * item.quantity + rib;
    }
  }, 0);
  const validateAddress = () => {
    const newErrors = {};
    if (!formAddressData.nickName) newErrors.nickName = "Nickname is required";
    if (!formAddressData.address1)
      newErrors.address1 = "Street address is required";
    if (!formAddressData.city) newErrors.city = "City is required";
    if (!formAddressData.state) newErrors.state = "State is required";
    if (!formAddressData.pincode) newErrors.pincode = "Postal code is required";
    if (!formAddressData.country) newErrors.country = "Country is required";
    if (!formAddressData.mobileNo)
      newErrors.mobileNo = "Phone number is required";
    if (!formAddressData.email) newErrors.email = "Email is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormAddressData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  useEffect(() => {
    fetchAllAddresses();
  }, [delivery]);

  const handleStateChange = (event) => {
    const selectedState = event.target.value;
    const stateData = statesData.find((state) => state.name === selectedState);
    setFormAddressData({ ...formAddressData, state: selectedState, city: "" });
    setCityOptions(stateData ? stateData.districts : []);
  };

  const handleCityChange = (e) => {
    const selectedCity = e.target.value;
    setFormAddressData((prev) => ({ ...prev, city: selectedCity }));
  };

  useEffect(() => {
    const stateData = statesData.find(
      (state) => state.name === formAddressData.state
    );
    setCityOptions(stateData ? stateData.districts : []);
  }, [formAddressData.state]);


  return (
    <>
      <div className="f-32 f-700 m-b-24 m-t-48">Shipping</div>
      <Modal
        size="lg"
        opened={isModalOpen}
        onClose={closeModal}
        title={
          <div style={{ fontWeight: "600", fontSize: "20px" }}>
            {LocationType[modelHeader]} Address
          </div>
        }
        transitionProps={{ transition: "fade", duration: 200 }}
        centered
      >
        <div className="body flex">
          <div className="addresses">
            <div style={{ overflowY: "auto" }}>
              {!addresses || addresses.length === 0 ? (
                <div>
                  <div className="no-address-message" style={{ color: "red" }}>
                    Please contact the salesperson for address information.
                  </div>
                  <div>
                    <span style={{ fontWeight: "bold" }}>
                      name : {customer?.salesMan?.name} <br />
                      phone Number : {customer?.salesMan?.mobile}
                    </span>
                  </div>
                </div>
              ) : (
                addresses.map((add, index) => (
                  <div className="card-address" key={add.nickName + index}>
                    <div className="c-address flex-fill" key={index}>
                      <div className="nickname">{add.nickName}</div>
                      <div className="location-info">
                        <div>{add.address1}</div>
                        <div>{add.address2}</div>
                        <div className="country">{add.country}</div>
                      </div>
                      <div className="contact-info">
                        <div className="ci-row">
                          <span className="address-key">Contact Name :</span>
                          <span className="address-value">{add.nickName}</span>
                        </div>
                        <div className="ci-row">
                          <span className="address-key">Contact Phone :</span>
                          <span className="address-value">{add.mobileNo}</span>
                        </div>
                        <div className="ci-row">
                          <span className="address-key">Contact Email :</span>
                          <span className="address-value">{add.email}</span>
                        </div>
                      </div>
                    </div>
                    {lastOrderByCustomer[0]?.[
                      modelHeader === "billLocation" ? 0 : 1
                    ] === add?.id && (
                        <div className="badge-last-used">Last used</div>
                      )}
                    <div className="flex-row g-8 m-t-16">
                      <button
                        className="btns btn-brd flex-fill p-12"
                        onClick={() => {
                          handleEdit(add);
                        }}
                      >
                        Edit
                      </button>
                      <button
                        className="btns btn-primary flex-fill p-12"
                        onClick={() => {
                          if (modelHeader === "shipLocation") {
                            setSelectedAddresses((prev) => ({
                              ...prev,
                              shipLocation: add,
                            }));
                          } else if (modelHeader === "billLocation") {
                            setSelectedAddresses((prev) => ({
                              ...prev,
                              billLocation: add,
                            }));
                          }
                          closeModal();
                        }}
                      >
                        {" "}
                        Use this address{" "}
                      </button>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>

      </Modal>

      <Modal
        size="lg"
        styles={{ content: { "--modal-y-offset": "12dvh" } }}
        centered
        opened={isSecondModalOpen}
        onClose={closeSecondModal}
        title={
          <div style={{ fontWeight: "600", fontSize: "20px" }}>
            {isEditMode ? "Edit Address" : "New Address"}
          </div>
        }
      >
        <div className="edit-body">
          <div className="form-address">
            <div className="form-control required field-nickname">
              <label className="flex-row items-center m-b-4 asterisk">
                <span className="flex-wrap">Address Nickname</span>
              </label>
              <div className="c-danger f-12 f-500 m-b-8">
                Please do not use a PO Box for your delivery address.
              </div>
              <Input
                name="nickName"
                value={formAddressData.nickName}
                error={errors.nickName}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-control required">
              <label className="display-block asterisk">Country</label>
              <Input
                name="country"
                value={formAddressData.country}
                error={errors.country}
                onChange={handleInputChange}
              />
            </div>

            <div className="address-hr"></div>

            <div className="form-control required field-street-1">
              <label className="flex-row items-center asterisk">
                <span className="flex-wrap"> Street 1</span>
              </label>
              <Input
                name="address1"
                value={formAddressData.address1}
                error={errors.address1}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-control field-street-2">
              <label className="flex-row items-center asterisk">
                <span className="flex-wrap"> Street 2</span>
              </label>
              <Input
                name="address2"
                value={formAddressData.address2}
                error={errors.address2}
                onChange={handleInputChange}
              />
            </div>

            <div className="sub-destination">
              <div className="sub-destination">
                <div className="form-control flex-fill m-b-0 required">
                  <label className="display-block asterisk">State</label>
                  <select
                    name="state"
                    value={formAddressData.state}
                    onChange={handleStateChange}
                  >
                    <option value="">Select State</option>
                    {statesData.map((state) => (
                      <option key={state.name} value={state.name}>
                        {state.name}
                      </option>
                    ))}
                  </select>
                  {errors.state && <div className="error">{errors.state}</div>}
                </div>

                <div className="form-control flex-fill m-b-0 required">
                  <label className="display-block asterisk">City</label>
                  <select
                    name="city"
                    value={formAddressData.city}
                    onChange={handleCityChange}
                    disabled={!cityOptions.length}
                  >
                    <option value="">Select City</option>
                    {cityOptions.map((city) => (
                      <option key={city} value={city}>
                        {city}
                      </option>
                    ))}
                  </select>
                  {errors.city && <div className="error">{errors.city}</div>}
                </div>
              </div>
            </div>

            <div className="form-control required field-postal-code">
              <label className="flex-row items-center asterisk">
                <span className="flex-wrap">Postal Code</span>
              </label>
              <Input
                name="pincode"
                value={formAddressData.pincode}
                error={errors.pincode}
                onChange={handleInputChange}
              />
            </div>

            <div className="address-hr"></div>

            <div className="input-phone form-control required field-phone">
              <label className="asterisk">Contact Phone</label>
              <Input
                name="mobileNo"
                value={formAddressData.mobileNo}
                error={errors.mobileNo}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-control required field-recipient-email">
              <label className="flex-row items-center asterisk">
                <span className="flex-wrap">Contact Email</span>
              </label>
              <Input
                name="email"
                value={formAddressData.email}
                error={errors.email}
                onChange={handleInputChange}
              />
            </div>

            <div className="bottom-buttons">
              <button className="btns btn-default" onClick={closeSecondModal}>
                Cancel
              </button>
              <button className="btns btn-primary" onClick={handleSave}>
                Save
              </button>
            </div>
          </div>
        </div>
      </Modal>

      <div
        className="adaptive-layout boundary-width-992 checkout-layout"
        style={{ gap: "24px" }}
      >
        <div className="first" id="fi">
          <div
            className="view-checkout-shipping checkout-route-view"
            agreed="true"
          >
            <div className="checkout-section-box">
              <div className="checkout-section-title checkout-section-header flex-row flex-between items-center">
                <div>Terms</div>
                <div className="f-14 c-gray-500" style={{ display: "flex", justifyContent: "flex-end" }}>
                  Ships from Tirupur, Tamilnadu
                </div>
              </div>
              <div className="checkout-section-body">
                <div className="shipping-parameters">
                  <div className="flex">
                    <div className="gray-box bordered shipping-fee">
                      <div className="attr">
                        <div className="key">Delivery Method</div>
                        <div>
                          <select
                            value={delivery}
                            onChange={handleDelveryModeChange}
                            style={{
                              color: deliveryModeError ? delivery === "" ? "red" : "black" : "black",
                            }}
                          >
                            <option value="" >Select Delivery Mode</option>
                            {valueOption
                              ?.filter(option => {
                                if ((sampleCart || swatchCart) && option === "PICKUP") return false;
                                return true;
                              })
                              .map(option => (
                                <option
                                  key={option}
                                  value={option}
                                  style={{ color: delivery === "" ? "black" : "" }}
                                >
                                  {(sampleCart || swatchCart) && option === "FREIGHT FORWARD" ? "COURIER" : option}
                                </option>
                              ))
                            }
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* <div className='checkout-section-box'>
                            <div className='checkout-section-title checkout-section-header flex-row  items-center'>
                                <div className='flex-wrap'>Duties & Taxes</div>
                                <div className='small-vr'></div>
                                <div className='f-500 c-primary'>India</div>
                            </div>
                            <div className='duties-taxes' style={{ fontSize: '14px' }}>
                                <div className='tax-estimation checkout-section-body'>
                                    <div className='item'>
                                        <div className='key'>
                                            <span>Estimated import fee</span>
                                        </div>
                                        <div className='flex-row f-600'>
                                            <div>Not available</div>
                                        </div>
                                    </div>
                                    <div className='item'>
                                        <div className='key'>
                                            <span>Estimated sales tax</span>
                                        </div>
                                        <div className='flex-row f-600'>
                                            <div>Not available</div>
                                        </div>
                                    </div>
                                    <div className='item'>
                                        <div className='key'>
                                            <span>Estimated handling fee</span>
                                        </div>
                                        <div className='flex-row f-600'>
                                            <div>Not available</div>
                                        </div>
                                    </div>
                                    <div className='item gray-info'>
                                        <div>
                                            Estimation above may be different from the actual amount. Charging customs duties/taxes are under your local customs department’s discretion.
                                        </div>
                                    </div>
                                </div>

                                <div className='warning'>
                                    The recipient may be required
                                    <b >additional information from the courier or the customs</b>
                                    . Packages will be returned or discarded
                                    <b >if not responded in time. Refunds are not permitted</b>
                                    in this case.
                                </div>
                            </div>
                        </div> */}

            {/* <div className='checkout-section-box' ref={addref}>
                            <div className='checkout-section-title checkout-section-header'>
                                Addresses
                            </div>
                            <div className='adaptive-layout boundary-width-768 shipping-addresses g-16' style={{ gap: '0px' }}>
                                {['billLocation', 'shipLocation'].map(address => (
                                    <div className='address-container required' key={address}>
                                        <div className='address-title'>
                                            {address === "billLocation" ? 'Billing' : 'Shipping'}
                                        </div>
                                        {selectedAddresses[address] ? (
                                            <div className="c-address-modifier">
                                                <div className="filled-container" onClick={() => openModal(address)} >
                                                    <div className="nickname" >{selectedAddresses[address].nickName}</div>
                                                    <div className="location-info">
                                                        <div>{selectedAddresses[address].address1}</div>
                                                        <div>{selectedAddresses[address].address2}</div>
                                                        <div className="country">{selectedAddresses[address].country}</div>
                                                    </div>
                                                    <div className="contact-info">
                                                        <div className="contact-info">
                                                            <div className="ci-row">
                                                                <span className="address-key">Contact Name</span>
                                                                <span className="address-value">{selectedAddresses[address].nickName}</span>
                                                            </div>
                                                            <div className="ci-row">
                                                                <span className="address-key">Contact Phone</span>
                                                                <span className="address-value">{selectedAddresses[address].mobileNo}</span>
                                                            </div>
                                                            <div className="ci-row">
                                                                <span className="address-key">Contact Email</span>
                                                                <span className="address-value">{selectedAddresses[address].email}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ) :
                                            <div className='c-address-modifier required-but-empty' addresstype="billing" ordertypr="fabric">
                                                <div className='empty-container' onClick={() => openModal(address)} style={{ cursor: 'pointer', border: addresserror && '1px solid red' }}>
                                                    <FontAwesomeIcon icon={faPlusCircle} color='#aab0bb' fontSize={32} />
                                                    <div className='f-16 f-600'>Select Address</div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                ))}
                            </div>
                        </div> */}

            <div className="checkout-section-box" ref={addref}>
              <div className="checkout-section-title checkout-section-header">
                Addresses
              </div>
              <div
                className="adaptive-layout boundary-width-768 shipping-addresses g-16"
                style={{ gap: "0px" }}
              >
                {(delivery === "PICKUP"
                  ? ["billLocation", "shipLocation"]
                  : ["billLocation", "shipLocation"]
                ).map((address) => (
                  <div className="address-container required" key={address}>
                    <div className="address-title">
                      {address === "billLocation" ? "Bill to" : "Ship to"}
                    </div>
                    {selectedAddresses[address] ? (
                      <div className="c-address-modifier">
                        <div
                          className="filled-container"
                          onClick={() => openModal(address)}
                        >
                          <div className="nickname">
                            {selectedAddresses[address].nickName}
                          </div>
                          <div className="location-info">
                            <div>{selectedAddresses[address].address1}</div>
                            <div>{selectedAddresses[address].address2}</div>
                            <div className="country">
                              {selectedAddresses[address].country}
                            </div>
                          </div>
                          <div className="contact-info">
                            <div className="ci-row">
                              <span className="address-key">Contact Name :</span>
                              <span className="address-value">
                                {selectedAddresses[address].nickName}
                              </span>
                            </div>
                            <div className="ci-row">
                              <span className="address-key">Contact Phone :</span>
                              <span className="address-value">
                                {selectedAddresses[address].mobileNo}
                              </span>
                            </div>
                            <div className="ci-row">
                              <span className="address-key">Contact Email :</span>
                              <span className="address-value">
                                {selectedAddresses[address].email}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div
                        className="c-address-modifier required-but-empty"
                        addresstype="billing"
                        ordertypr="fabric"
                      >
                        <div
                          className="empty-container"
                          onClick={() => openModal(address)}
                          style={{
                            cursor: "pointer",
                            border: addresserror && "1px solid red",
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faPlusCircle}
                            color="#aab0bb"
                            fontSize={32}
                          />
                          <div className="f-16 f-600">Select Address</div>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="second required">
          <div
            className="conditional-sticky"
            style={{
              top: "calc(16px + var(--app-header-height))",
              position: "sticky",
              marginTop: "0px",
              zIndex: "2",
            }}
          >
            <div className="cart-price-summary card-price-summary">
              <div className="header">{getCartType()}</div>
              <div className="subtotal-explanation">
                {swatchCart && (<div> <div className="row">
                  <div className="key">Loyalty points :</div>
                  <div className="value">{profile?.loyaltyAmount} points</div>
                </div>
                  {(loyalty?.minRedeemPoints || 0) > 0 && <div className="row">
                    <div className="key">Minimum redeem points :</div>
                    <div className="value">{loyalty?.minRedeemPoints} points </div>
                  </div>}</div>)}


                <div className="row">
                  <div className="row">
                    <div className="key">Subtotal ({getTotalLabel()})</div>
                    <div className="value">   {getCartType() !== "Swatch Cart" ? `₹ ${subtotall.toFixed(2)}` : `${subtotall.toFixed(2)} points`}</div>
                  </div>
                </div>
                {swatchCart && (profile?.loyaltyAmount != null ||profile?.loyaltyAmount>0 ) && (
                  <div className="row">
                    <div className="key">
                      <div style={{ fontSize: "12px", color: "#888" }}>
                        ( Loyalty Points - Subtotal )
                      </div>
                      Remaining Loyalty points :
                    </div>

                        <div className="value">
                        {(
                          (profile?.loyaltyAmount || 0) - subtotall
                        ).toFixed(2)}{" "}
                        {getCartType() !== "Swatch Cart" ? "₹" : "points"}
                      </div>
                  </div>
                )}
                <div className="shipping-fee row">

                </div>
              </div>

              <div className="total">
                {swatchCart && cartData.length > 0 && (
                  <div className="total">
                    {/* {profile?.loyaltyAmount > subtotall && (<div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", color: "gray" }}>

                    <div style={{ display: "flex", flexDirection: "column" }}> {subtotall < loyalty?.minRedeemPoints && (<span style={{ fontSize: "12px", color: "red" }}>
                     Subtotal points should more than or equal to min redeem points</span>)}
                    {subtotall >= loyalty?.minRedeemPoints && (  <span style={{ fontSize: "12px", display: "flex", justifyContent: "flex-end" }}>
                        subtotal {subtotall.toFixed(2)} reduced from loalty {profile?.loyaltyAmount.toFixed(2)}</span> )}</div></div>
                  )} */}
                  </div>)}
                <div className="row">
                  <div className="key">Total</div>
                  <div className="value"> {getCartType() !== "Swatch Cart" ? `₹ ${subtotall.toFixed(2)}` : `${subtotall.toFixed(2)} points`}</div>
                </div>
              </div>

            </div>

            <div className="flex g-8">
              {deliveryModeError && (
                <>
                  <div style={{ display: "flex" }}>
                    <span style={{ color: "gray", fontWeight: "bold", marginRight: "3px", fontSize: "14px" }}>NOTE : </span>
                    <span style={{ display: "flex", color: "red", marginTop: "0px" }}>
                      Please select a delivery mode
                    </span> {isMobile && <span className="arrow-for-mobile" style={{ marginLeft: "3px", fontSize: "14px", color: "red", fontWeight: 900 }}>↑</span>}</div> </>
              )}

              <B2BButton
                name={"Continue to policy"}
                color={"#8BC53F"}
                style={{
                  fontWeight: 600,
                  height: "48px",
                  boxShadow: "0 3px 6px 0 rgba(0,0,0,.16)",
                }}
                onClick={() => {
                  const isDeliverySelected = handleSubmit();
                  const isBillingFilled = selectedAddresses["billLocation"];
                  const isShippingFilled = selectedAddresses["shipLocation"];

                  if (isDeliverySelected) {
                    if (delivery === "PICKUP" && isBillingFilled) {
                      setAddressError(false);
                      handleNextStep();
                    } else if (
                      delivery === "FREIGHT FORWARD" &&
                      isBillingFilled &&
                      isShippingFilled
                    ) {
                      setAddressError(false);
                      handleNextStep();
                    } else {
                      setAddressError(true);
                      handleRefAddress();
                    }
                  }
                }}
              />
            </div>

            <div className="checkout-optional-sections"></div>
          </div>
        </div>
      </div>
    </>
  );
}
